<template>
    <router-view :key="$route.path"></router-view>
</template>

<script>

import { reactive, provide, watch } from 'vue'

export default {
    setup() {
        const globalState = reactive({
            loadingTasks: 0,
            loading: true
        })

        provide('globalState', globalState)

        watch(
            () => globalState.loadingTasks,
            (loadingTasks) => {
                if(loadingTasks == 0)
                    globalState.loading = false
            }
        )
    }
}
</script>

<style lang="css" scoped>

</style>